import { HttpErrorResponse } from "@angular/common/http";
import { ChangeDetectionStrategy, Component, Injector, OnInit } from "@angular/core";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { catchError, tap } from "rxjs/operators";
import { StakeholderServicesService } from "../stakeholder-services.service";

@Component({
    selector: "adapt-trigger-stewardship-activity",
    templateUrl: "./trigger-stewardship-activity.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TriggerStewardshipActivityComponent extends BaseRoutedComponent implements OnInit {
    public activityWebjobTriggerResult = "";

    public constructor(private stakeholderServices: StakeholderServicesService, injector: Injector) {
        super(injector);
    }

    public ngOnInit() {
        this.notifyActivated();
    }

    @Autobind
    public triggerWebjob() {
        return this.stakeholderServices.triggerStewardshipActivityWebjob().pipe(
            tap((result) => this.activityWebjobTriggerResult = result),
            catchError((error: HttpErrorResponse) => this.activityWebjobTriggerResult = error.error),
        );
    }
}
